import accountSettingsModule from '../accountSettingsModule';

function commonConstantsService($log, languageResource) {
  'ngInject';

  const ls = languageResource;
  return {
    validation: {
      invalid: {
        socialMedia: ls.get('Response.SocialMedia.ValidationError')
      }
    },
    label: {
      country: ls.get('Label.Country'),
      twoStepEmail: ls.get('Label.TwoStepEmail'),
      changeUsername: ls.get('Label.ChangeYourUsername'),
      useDeviceLanguage: ls.get('Label.UseDeviceLanguage')
    },
    tabs: {
      info: ls.get('Heading.Tab.AccountInfo'),
      security: ls.get('Heading.Tab.Security'),
      privacy: ls.get('Heading.Tab.Privacy'),
      billing: ls.get('Heading.Tab.Billing'),
      notifications: ls.get('Heading.Tab.Notifications'),
      fastTrack: ls.get('Heading.Tab.FastTrack')
    },
    billingHistory: {
      noHistory: ls.get('Label.BillingHistoryNoTransactions'),
      historyError: ls.get('Label.BillingHistoryGeneralErrors')
    }
  };
}

accountSettingsModule.factory('commonConstantsService', commonConstantsService);

export default commonConstantsService;
